module.exports = __webpack_public_path__ + "img/del.5b405dc9.png";